import { create } from "zustand";
import { persist } from "zustand/middleware";

export type DatePreset = "1d" | "7d" | "30d" | "90d";

interface DateRangeState {
  preset: DatePreset;
  days: number;
  label: string;
  setPreset: (preset: DatePreset) => void;
}

const PRESETS: Record<DatePreset, { days: number; label: string }> = {
  "1d": { days: 1, label: "Today" },
  "7d": { days: 7, label: "Last 7 days" },
  "30d": { days: 30, label: "Last 30 days" },
  "90d": { days: 90, label: "Last 90 days" },
};

export const useDateRange = create<DateRangeState>()(
  persist(
    (set) => ({
      preset: "7d",
      days: 7,
      label: "Last 7 days",
      setPreset: (preset: DatePreset) => {
        const { days, label } = PRESETS[preset];
        set({ preset, days, label });
      },
    }),
    { name: "sati-date-range" },
  ),
);

export { PRESETS };
